import getConfig from 'next/config';

export const isIteroEcommerceEnabled = (): boolean => {
  const { publicRuntimeConfig } = getConfig();

  if (publicRuntimeConfig && publicRuntimeConfig.ENABLE_ITERO_ECOMMERCE) {
    return publicRuntimeConfig.ENABLE_ITERO_ECOMMERCE.toLowerCase() === 'true';
  }
  return false;
};
